module.exports = __webpack_public_path__ + "img/ch8pic5.faf26219.png";